export default __webpack_public_path__ + "static/media/gesundheitpflege_light.892e0d16.png";